const { createSlice } = require("@reduxjs/toolkit");

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    username: null,
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload.user;
      state.username = action.payload.username;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;
